import { createSvg } from '@r1-frontend/ui-react/components/svg/createSvg';
var TickSquare = function (_a) {
    var _b = _a.strokeWidth, strokeWidth = _b === void 0 ? 1.5 : _b;
    return <>
        <g id={'contour'}>
            <path d='M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
        </g>
        <g id={'guts'}>
            <path d='M7.75 12L10.58 14.83L16.25 9.17' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
        </g>
    </>;
};
export default createSvg(TickSquare, 'tick-square');
